import { render, staticRenderFns } from "./GameMcq.vue?vue&type=template&id=013a1b6b&scoped=true"
import script from "./GameMcq.vue?vue&type=script&lang=js"
export * from "./GameMcq.vue?vue&type=script&lang=js"
import style0 from "./GameMcq.vue?vue&type=style&index=0&id=013a1b6b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013a1b6b",
  null
  
)

export default component.exports